import SyntheseEntitiesExclusionController from './syntheseentities.exclusion.controller';

export default {
    bindings: {
        syntheseEntity: '=',
        forGeneration: '=',
        ongletOpen: '='
    },
    template: require('./syntheseentities.exclusion.html'),
    controller: SyntheseEntitiesExclusionController
};
